<template>
  <section class="section">
    <div class="container-fluid grid">
      <div>
        <div class="cr_item flexing-3">
          <div class="cr_item_content" v-if="!isForgetPassword">
            <h1 class="text-center">Log In</h1>

            <ul class="cr_steps" style="width: 100%">
              <!-- <li class="active"></li> -->
            </ul>
            <uform style="max-width: 600px">
              <div
                class="alert alert-info"
                role="alert"
                v-if="oldUser && !isSignin"
              >
                You need to create an Upskill account with associated email to
                enable social login option
              </div>
              <!--              login-->
              <ulabel size="12" v-if="isSignin">
                <uinput
                  placeholder="Email*"
                  v-model="model.email"
                  @keypress.native.enter="login"
                  suggest="yourmail@email.com"
                ></uinput>
              </ulabel>
              <ulabel size="12" v-if="isSignin">
                <uinput
                  placeholder="Password*"
                  type="password"
                  @keypress.native.enter="login"
                  v-model="model.password"
                  suggest="Password (minimum 8 characters)"
                ></uinput>
              </ulabel>
              <div class="group" v-if="!isSignin">
                <input
                  type="text"
                  class="form_input"
                  placeholder="This name will be used in certificate"
                  id="uphone"
                  v-model="form.name"
                  name="name"
                />
                <label for="uphone">Full Name*</label>
              </div>
              <div class="group" v-if="!isSignin">
                <input
                  type="text"
                  class="form_input"
                  placeholder="Contact email"
                  id="uphone"
                  v-model="form.email"
                />
                <label for="uphone">Email*</label>
              </div>
              <div class="group" v-if="!isSignin">
                <input
                  type="text"
                  class="form_input"
                  placeholder="ie. 017XXXXXXXX"
                  id="uphone"
                  v-model="form.phone"
                />
                <label for="uphone">Phone Number*</label>
              </div>
              <div class="group" v-if="!isSignin">
                <input
                  type="password"
                  class="form_input"
                  placeholder="Password must contain at least 8 characters"
                  id="uphone"
                  v-model="form.password"
                />
                <label for="uphone">Password*</label>
              </div>
              <div class="member-flex">
                <!-- <a href="
              "  @click.native.prevent="isForgetPassword = true">
                Forgot password?
              </a> -->

                <ubtn
                  class="forget-button"
                  @click.native.prevent="isForgetPassword = true"
                  >Forgot password?</ubtn
                >
              </div>
              <ulabel size="6">
                <Primary_button
                  v-if="isSignin"
                  class=" text-center"
                  @click.prevent.native="login"
                  :loading="btnLoading"
                  >Log In</Primary_button
                >

                <ubtn
                  v-else
                  class="mx-auto text-center"
                  @click.prevent.native="signup"
                  :loading="btnLoading"
                  >SIGN UP</ubtn
                >
              </ulabel>
            </uform>
            <div>
              <div class="separator">or</div>
            </div>
            <ulabel size="12">
              <ubtn
                class="mx-auto google"
                @click.prevent.native="socialSignin"
                :loading="btnLoading"
                v-if="isSignin"
                ><img
                  src="../assets/icons/google-brands.svg"
                  style="max-width:25px;     margin-right: 44px;margin-left: -64px;"
                  alt=""
                /><span>CONTINUE WITH GOOGLE</span></ubtn
              >
            </ulabel>
            <ulabel size="12">
              <ubtn
                class="mx-auto facebook"
                @click.prevent.native="socialSignin('facebook')"
                :loading="btnLoading"
                v-if="isSignin"
                ><img
                  src="../assets/icons/facebook-brands.svg"
                  style="max-width:25px; margin-right:45px; margin-left:-45px;"
                  alt=""
                />
                <span>CONTINUE WITH FACEBOOK</span></ubtn
              >
            </ulabel>
            <!-- <ulabel size="12" v-if="isSignin">
              <ubtn
                class="mx-auto email"
                @click.prevent.native="isSignin = false"
                :loading="btnLoading"
                ><i style="margin-left: -2em" class="fa fa-envelope fa-x g"></i
                ><span>SIGNUP WITH EMAIL</span></ubtn
              >
            </ulabel>

            <ulabel size="12" v-else>
              <ubtn
                class="mx-auto email"
                @click.prevent.native="isSignin = true"
                :loading="btnLoading"
                ><i class="fa fa-envelope fa-x g"></i
                ><span>LOGIN WITH EMAIL</span></ubtn
              >
            </ulabel> -->
            <p class="text-center new_to_upskill">
              New to Upskill?
              <a href="/signup"> Sign up</a>
            </p>

            <p class="text-center queries">
              For any problem with sign in please send mail to<br />
              <span>
                upskill@upskillbangladesh.com
              </span>
            </p>
          </div>
          <div class="cr_item_content" v-if="isForgetPassword">
            <h1>Please write down the email you've used for registration</h1>
            <!--

            <ul class="cr_steps" style="width: 100%;">
              <li class="active"></li>
            </ul> -->
            <uform style="max-width: 600px">
              <ulabel size="12">
                <uinput placeholder="Email*" v-model="fp_email"></uinput>
              </ulabel>
              <ulabel size="6">
                <ubtn
                  class="mx-auto"
                  @click.prevent.native="fpSubmit"
                  :loading="btnLoading"
                  >Submit</ubtn
                >
              </ulabel>
              <ulabel size="6"> </ulabel>
            </uform>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import firebase from 'firebase'
import axios from 'axios'

import Primary_button from '../components/Design_System/buttons/Primary_button.vue'
export default {
  components: { Primary_button },
  data() {
    return {
      model: {},
      oldUser: false,
      form: {},
      btnLoading: false,
      loading: false,
      fp_email: '',
      isForgetPassword: false,
      isSignin: true,
    }
  },
  methods: {
    socialSignin(type) {
      let provider = new firebase.auth.GoogleAuthProvider()
      if (type == 'facebook') {
        provider = new firebase.auth.FacebookAuthProvider()
      }
      // eslint-disable-next-line
      firebase
        .auth()
        .signInWithPopup(provider)
        // eslint-disable-next-line
        .then((asd) => {
          // eslint-disable-next-line
          // console.log(asd)
          // let idToken = res.credential.idToken
          firebase
            .auth()
            .currentUser.getIdToken()
            .then((res) => {
              let token = res.toString()
              // console.log(token)
              axios
                .get(this.$upskill.socialLink(), {
                  headers: { 'X-Auth-Secret': token },
                })
                .then((res2) => {
                  if (!res2.data.code) {
                    this.btnLoading = false
                    localStorage.removeItem('token')
                    localStorage.setItem('token', res2.data.token)
                    this.pendingHook()
                  } else {
                    this.oldUser = true
                    this.form.name = res2.data.data.displayName
                    this.form.email = res2.data.data.email
                    this.isSignin = false
                    // let target = document.getElementById("register");
                    // this.$animate(target);
                  }
                  // eslint-disable-next-line
                })
                // eslint-disable-next-line
                .catch((err) => {
                  // console.log(err)
                  this.btnLoading = false
                  this.ErrorAlert('Invalid credentials!')
                })
            })
          // this.login2(idToken)
          // eslint-disable-next-line
        })
        // eslint-disable-next-line
        .catch((err2) => {
          // eslint-disable-next-line
          this.ErrorAlert(
            'The email used for this account is already used by another provider (ie. Facebook/Google) used to log into Upskill'
          )
        })
    },
    // showAlert() {
    //   this.SuccessAlert("Please put correct email/password");
    // },
    login() {
      this.btnLoading = true
      this.$upskill
        .loginUser(this.model)
        .then((res) => {
          this.btnLoading = false
          localStorage.removeItem('token')
          localStorage.setItem('token', res.data.token)
          this.pendingHook()
        })
        .catch(() => {
          this.btnLoading = false
          this.ErrorAlert('Please put correct email/password')
        })
    },
    login2(token) {
      this.btnLoading = true
      this.$upskill
        .social(token)
        .then((res) => {
          this.btnLoading = false
          localStorage.removeItem('token')
          localStorage.setItem('token', res.data.token)
          this.pendingHook()
        })
        .catch(() => {
          this.btnLoading = false
          this.ErrorAlert('Invalid credentials!')
        })
    },
    pendingHook() {
      let pw = this.PendingWorkshop()
      if (pw) {
        localStorage.removeItem('pendingWorkshop')
        this.TimerAlert(
          'Please wait...',
          'We are registering you for the workshop!',
          500
        )
        // this.GotoWS(pw);
        this.joinWorkshop(pw)
      } else {
        let pi = this.GetPendingInvoice()
        if (pi) {
          this.RemovePendingInvoice()
          this.$router.push({ name: 'invoice' })
        } else {
          //this.SuccessAlert("Logged in!");
          this.Goto({ name: 'user_profile' })
        }
      }
    },
    validateEmail() {
      var re = /\S+@\S+\.\S+/
      return re.test(this.form.email)
    },
    signup() {
      this.SetFirstTimer()
      this.loading = true
      if (
        !this.form.phone ||
        !this.form.email ||
        !this.form.password ||
        !this.form.name
      ) {
        this.ErrorAlert('Please fill up all the fields')
        this.loading = false
      } else if (this.form.phone.length != 11) {
        this.ErrorAlert('Provide a valid phone number')
        this.loading = false
      } else if (!this.validateEmail()) {
        this.ErrorAlert('Provide a valid email')
        this.loading = false
      } else if (!this.form.password.length > 7) {
        this.ErrorAlert('Password must contain at least 8 characters')
      } else {
        // console.log("triggered");
        this.siteRegister()
      }
    },
    siteRegister() {
      let validResponse = false
      this.$upskill
        .oldRegister(this.form)
        .then((res) => {
          // this.SetFirstTimer()
          validResponse = true
          this.loading = false
          localStorage.removeItem('token')
          localStorage.setItem('token', res.data.token)
          this.pendingHook()
        })
        .catch((error) => {
          this.loading = false
          if (!validResponse) {
            this.ErrorAlert(error.response.data.message)
          }
        })
    },
    joinWorkshop(id) {
      localStorage.removeItem('pendingWorkshop')
      this.$upskill
        .join(id)
        .then(() => {
          this.loading = false
          //this.SuccessAlert("You are registered for the workshop. Please complete the purchase by clicking the pay button (ignore if the workshop is free)");
          this.SuccessAlert('Registered! Proceed to payment')
          this.GotoWS(id)
          // this.GotoProfile()
        })
        .catch(() => {
          this.loading = false
          this.Goto({ name: 'thanks' })
          this.GotoWS(id)
          // this.GotoProfile()
        })
    },
    fpSubmit() {
      this.btnLoading = true
      this.$upskill
        .pwInit(this.fp_email)
        .then(() => {
          this.btnLoading = false
          this.SuccessAlert(
            'An email has been sent your inbox! Please check for further instructions.'
          )
          this.isForgetPassword = false
        })
        .catch(() => {
          this.btnLoading = false
          this.SuccessAlert(
            'An email has been sent your inbox! Please check for further instructions.'
          )
          this.isForgetPassword = false
        })
    },
  },
  created() {
    this.Loaded()
  },
}
</script>

<style scoped>
.google span {
  font: 400 0.875rem/1.375rem 'Open Sans';
}
.facebook span {
  font: 400 0.875rem/1.375rem 'Open Sans';
}
p.new_to_upskill {
  margin-top: 30px;
  font: 400 0.875rem/1.375rem 'Open Sans';
  margin-bottom: 105px;
}
p.already_login {
  margin-top: 20px;
  font: 400 0.875rem/1.375rem 'Open Sans';
  margin-bottom: 55px;
}
.separator {
  display: flex;
  align-items: center;
  text-align: center;
}
p.queries {
  font: 400 0.875rem/1.375rem 'Open Sans';
  letter-spacing: -0.14px;
}
p.queries span {
  font: 400 1.125rem/1.81rem 'Open Sans';
  letter-spacing: -0.18px;
  color: #0062ff;
}
.separator {
  padding-top: 10px;
  display: flex;
  align-items: center;
  text-align: center;
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #728391;
}

.separator:not(:empty)::before {
  margin-right: 0.25em;
}

.separator:not(:empty)::after {
  margin-left: 0.25em;
}
.signup {
  margin-top: 25px;
  background: #013686 0% 0% no-repeat padding-box;
  display: flex;
  padding: 20px;
  flex-wrap: wrap;
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
}
.form_input {
  font: 400 0.875rem/1.375rem 'Open Sans' !important;
  border: 1px solid #9a9abe;
  border-radius: var(--button_radius_4);
  min-height: 50px;
  padding: 10px 15px;
  outline: none;
  max-width: 380px;
  width: 100%;
  background: #ffffff;
  margin: 10px 0px;
}
.form_input:active {
  box-shadow: 0px 0px 0px 1px var(--primary_color);
}
.form_input:focus {
  box-shadow: 0px 0px 0px 1px var(--primary_color);
}

label {
  font: 400 0.875rem/1.375rem 'Open Sans' !important;
  color: #999;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 3px;
  top: -20px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
.group {
  position: relative;
  width: 100%;
  margin-top: 20px;
}
.signin-title {
  margin-left: auto;
  margin-right: auto;
  font-family: 'Open Sans', sans-serif;
  font-size: 30px;
  letter-spacing: 4px;
  /*letter-spacing: -2.5px;*/
  color: #fff;
}
.grid {
  display: grid;
  grid-template-columns: 1fr;
  padding-left: 0;
  padding-right: 0;
  min-height: 65vh;
}
.flexing-2 {
  display: flex;
  /* background: transparent url('../assets/daniel-olah-1Vt21LuLSug-unsplash.svg') 0% 0% no-repeat padding-box;
  */
  background-color: #460f99;
  background-image: linear-gradient(315deg, #460f99 0%, #7201f4 74%);
  opacity: 1;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
.flexing-2 h1 {
  letter-spacing: -2px;
  color: #ffffff;
  opacity: 1;
  font-size: 40px;
  font-family: 'Open Sans';
  font-weight: 700;
}
.flexing-2 p {
  letter-spacing: -0.18px;
  color: #ffffff;
  opacity: 1;
  font-size: 14px;
  font-family: 'Open Sans';
  font-weight: 400;
}
.flexing-3 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.flexing-3 h1 {
  text-align: center;
  padding-top: 50px;
  font: 700 1.5rem/2rem 'Open Sans';
  letter-spacing: -1.2px;
}
.fb {
  padding-right: 2.5em;
}
.g {
  padding-right: 2.75em;
}
.google {
  background-color: #dd4b39 !important;
  text-align: center;
}
.facebook {
  background-color: #4267b2 !important;
}

.email {
  background-color: #545252 !important;
}
.registration_next {
  text-transform: uppercase;
  color: #fff;
  background-color: #0062ff;
  border-radius: 4px;
  padding: 15px;
  width: 380px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  margin-top: 24px;
}
.cr_booking_form .cr_form_input {
  width: 100%;
  border: none;
  border-bottom: 1px solid red !;
  margin-bottom: 25px;
  padding-bottom: 8px;
}
.member-flex {
  width: 100%;
  /* display: flex;
  flex-direction: row; */
  /* justify-content: flex-start; */
  /* align-items: flex-end; */
  /* margin: 0 10px; */
}
/* .cr_booking_form .cr_form_item_full {
  padding-left: 1;
  padding-right: 0;
} */
.phn {
  border-top: none;
  border-left: none;
  border-right: none;
  background: none;
  width: 70%;
  margin-left: 0.5em;
}
.phn-text {
  font-weight: 600;
  color: rgb(0, 51, 102);
  font-size: 14px;
}
.cr_item_content {
  max-width: 380px;
  margin-bottom: 160px;
}
.needs-flex {
  margin: 35px auto;
}
.details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.forget-button {
  width: 50%;
  margin: 0;
  margin-top: 10px;
  background: none;
  color: var(--primary_color);
  border: none;
  box-shadow: none;
  padding: 0;
  padding-left: 10px;
  font: 400 0.875rem/1.375rem 'Open Sans';
  cursor: pointer;
  text-transform: none;
  text-align: left;
}
.cr_booking_form .cr_form_item_full {
  padding-left: 0;
}
@media only screen and (max-width: 600px) {
  .cr_item_content {
    max-width: 345px;
    margin-bottom: 160px;
  }
  .registration_next {
    width: 345px;
  }
  .grid {
    display: grid;
    grid-template-columns: 1fr;
    padding-left: 15;
    padding-right: 15;
    min-height: 65vh;
  }
  .flexing-3 {
    padding: 25px 15px;
    grid-row: 1;
  }
  .flexing-2 h1 {
    letter-spacing: -2px;
    color: #ffffff;
    opacity: 1;
    font-size: 25px;
    font-family: 'Open Sans';
    font-weight: 700;
    text-align: center;
  }
  .flexing-2 p {
    letter-spacing: -0.18px;
    color: #ffffff;
    opacity: 1;
    font-size: 12px;
    font-family: 'Open Sans';
    font-weight: 400;
    text-align: center;
  }
}

.alert {
  width: 100%;
  padding: 12px 16px;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  margin-bottom: 12px;
  font-size: 16px;
}

.alert.alert-success {
  background-color: rgba(227, 253, 235, 1);
  border-color: rgba(38, 179, 3, 1);
  color: rgba(60, 118, 61, 1);
}

.alert.alert-info {
  max-width: 380px;
  background-color: #fed500;
  color: #444446;
  font: 400 1rem/1.375rem 'Open Sans' !important;
  border: none;
}

.alert.alert-warning {
  background-color: rgba(252, 248, 227, 1);
  border-color: rgba(177, 161, 129, 1);
  color: rgba(138, 109, 59, 1);
}

.alert.alert-danger {
  background-color: rgba(248, 215, 218, 1);
  border-color: rgba(220, 53, 69, 1);
  color: rgba(114, 28, 36, 1);
}
</style>
